import { Icon, Grid, GridItem, Text } from '@chakra-ui/react';
import { inspireYellow } from '@inspire/ui/static';
import { MdTipsAndUpdates } from 'react-icons/md';

const TextComponent = () => (
  <>
    <Text textAlign={'justify'}>
      Les pistes d’études sont des domaines de formation qui semblent te
      correspondre en fonction des réponses que tu as donné dans le quiz lors de
      ton inscription. Ces recommandations se basent sur :
    </Text>
    <ul>
      <li> tes notes</li>
      <li>tes goûts pour les matières et les domaines qui t’intéressent</li>
      <li> ton type de bac</li>
      <li> le type d’encadrement et de structure souhaitée</li>
      <li> tes activités extrascolaires</li>
    </ul>
    <Text textAlign={'justify'}>
      Les premières pistes sont celles qui te correspondent le plus d’après le
      quiz mais n’hésites pas à tout regarder pour t’informer sur tes
      différentes options d’orientation !
    </Text>
  </>
);

const ExplicationResultatsPistesRecommendees = ({
  isMobile,
}: {
  isMobile?: boolean;
}) => {
  if (isMobile) {
    return <TextComponent />;
  }
  return (
    <>
      <Grid templateAreas={`"icon text"`} gridTemplateColumns={'100px'}>
        <GridItem area={'icon'} position={'relative'}>
          <Icon
            as={MdTipsAndUpdates}
            color={inspireYellow}
            boxSize={'70px'}
            position={'absolute'}
            top={'40%'}
          />
        </GridItem>
        <GridItem area={'text'}>
          <TextComponent />
        </GridItem>
      </Grid>
    </>
  );
};

export default ExplicationResultatsPistesRecommendees;
